export const StakingViewer_Contract_ABI = [
  {
    inputs: [
      { internalType: "address", name: "_stakingController", type: "address" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      { internalType: "address[]", name: "provers", type: "address[]" },
      { internalType: "uint256[]", name: "shares", type: "uint256[]" },
    ],
    name: "batchConvertToAssets",
    outputs: [{ internalType: "uint256[]", name: "assets", type: "uint256[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "provers", type: "address[]" },
      { internalType: "uint256[]", name: "assets", type: "uint256[]" },
    ],
    name: "batchConvertToShares",
    outputs: [{ internalType: "uint256[]", name: "shares", type: "uint256[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address[]", name: "provers", type: "address[]" }],
    name: "batchGetStakerCounts",
    outputs: [
      { internalType: "uint256[]", name: "stakerCounts", type: "uint256[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "provers", type: "address[]" },
      { internalType: "uint256[]", name: "assets", type: "uint256[]" },
    ],
    name: "batchPreviewStake",
    outputs: [
      { internalType: "uint256[]", name: "shares", type: "uint256[]" },
      { internalType: "bool[]", name: "eligible", type: "bool[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "uint256", name: "assets", type: "uint256" },
    ],
    name: "convertAssetsToShares",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "uint256", name: "shares", type: "uint256" },
    ],
    name: "convertSharesToAssets",
    outputs: [{ internalType: "uint256", name: "assets", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllActiveProversInfo",
    outputs: [
      {
        components: [
          { internalType: "address", name: "prover", type: "address" },
          {
            internalType: "enum IStakingController.ProverState",
            name: "state",
            type: "uint8",
          },
          { internalType: "address", name: "vault", type: "address" },
          { internalType: "uint256", name: "vaultAssets", type: "uint256" },
          { internalType: "uint256", name: "vaultShares", type: "uint256" },
          { internalType: "uint256", name: "totalAssets", type: "uint256" },
          { internalType: "uint256", name: "totalUnstaking", type: "uint256" },
          { internalType: "uint256", name: "numStakers", type: "uint256" },
          { internalType: "uint64", name: "joinedAt", type: "uint64" },
          { internalType: "uint256", name: "slashingScale", type: "uint256" },
          {
            internalType: "uint256",
            name: "pendingCommission",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "defaultCommissionRate",
            type: "uint64",
          },
          {
            components: [
              { internalType: "address", name: "source", type: "address" },
              { internalType: "uint64", name: "rate", type: "uint64" },
            ],
            internalType: "struct IStakingViewer.ProverCommissionInfo[]",
            name: "commissionRates",
            type: "tuple[]",
          },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "iconUrl", type: "string" },
        ],
        internalType: "struct IStakingViewer.ProverDisplayInfo[]",
        name: "proversInfo",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverInfo",
    outputs: [
      {
        components: [
          { internalType: "address", name: "prover", type: "address" },
          {
            internalType: "enum IStakingController.ProverState",
            name: "state",
            type: "uint8",
          },
          { internalType: "address", name: "vault", type: "address" },
          { internalType: "uint256", name: "vaultAssets", type: "uint256" },
          { internalType: "uint256", name: "vaultShares", type: "uint256" },
          { internalType: "uint256", name: "totalAssets", type: "uint256" },
          { internalType: "uint256", name: "totalUnstaking", type: "uint256" },
          { internalType: "uint256", name: "numStakers", type: "uint256" },
          { internalType: "uint64", name: "joinedAt", type: "uint64" },
          { internalType: "uint256", name: "slashingScale", type: "uint256" },
          {
            internalType: "uint256",
            name: "pendingCommission",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "defaultCommissionRate",
            type: "uint64",
          },
          {
            components: [
              { internalType: "address", name: "source", type: "address" },
              { internalType: "uint64", name: "rate", type: "uint64" },
            ],
            internalType: "struct IStakingViewer.ProverCommissionInfo[]",
            name: "commissionRates",
            type: "tuple[]",
          },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "iconUrl", type: "string" },
        ],
        internalType: "struct IStakingViewer.ProverDisplayInfo",
        name: "proverInfo",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address[]", name: "provers", type: "address[]" }],
    name: "getProversInfo",
    outputs: [
      {
        components: [
          { internalType: "address", name: "prover", type: "address" },
          {
            internalType: "enum IStakingController.ProverState",
            name: "state",
            type: "uint8",
          },
          { internalType: "address", name: "vault", type: "address" },
          { internalType: "uint256", name: "vaultAssets", type: "uint256" },
          { internalType: "uint256", name: "vaultShares", type: "uint256" },
          { internalType: "uint256", name: "totalAssets", type: "uint256" },
          { internalType: "uint256", name: "totalUnstaking", type: "uint256" },
          { internalType: "uint256", name: "numStakers", type: "uint256" },
          { internalType: "uint64", name: "joinedAt", type: "uint64" },
          { internalType: "uint256", name: "slashingScale", type: "uint256" },
          {
            internalType: "uint256",
            name: "pendingCommission",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "defaultCommissionRate",
            type: "uint64",
          },
          {
            components: [
              { internalType: "address", name: "source", type: "address" },
              { internalType: "uint64", name: "rate", type: "uint64" },
            ],
            internalType: "struct IStakingViewer.ProverCommissionInfo[]",
            name: "commissionRates",
            type: "tuple[]",
          },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "iconUrl", type: "string" },
        ],
        internalType: "struct IStakingViewer.ProverDisplayInfo[]",
        name: "proversInfo",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSystemOverview",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "totalVaultAssets",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalActiveVaultAssets",
            type: "uint256",
          },
          { internalType: "uint256", name: "totalProvers", type: "uint256" },
          { internalType: "uint256", name: "activeProvers", type: "uint256" },
          { internalType: "uint256", name: "totalStakers", type: "uint256" },
          { internalType: "uint256", name: "minSelfStake", type: "uint256" },
          { internalType: "uint256", name: "unstakeDelay", type: "uint256" },
          { internalType: "address", name: "stakingToken", type: "address" },
        ],
        internalType: "struct IStakingViewer.SystemOverview",
        name: "overview",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "limit", type: "uint256" }],
    name: "getTopProvers",
    outputs: [
      {
        components: [
          { internalType: "address", name: "prover", type: "address" },
          {
            internalType: "enum IStakingController.ProverState",
            name: "state",
            type: "uint8",
          },
          { internalType: "address", name: "vault", type: "address" },
          { internalType: "uint256", name: "vaultAssets", type: "uint256" },
          { internalType: "uint256", name: "vaultShares", type: "uint256" },
          { internalType: "uint256", name: "totalAssets", type: "uint256" },
          { internalType: "uint256", name: "totalUnstaking", type: "uint256" },
          { internalType: "uint256", name: "numStakers", type: "uint256" },
          { internalType: "uint64", name: "joinedAt", type: "uint64" },
          { internalType: "uint256", name: "slashingScale", type: "uint256" },
          {
            internalType: "uint256",
            name: "pendingCommission",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "defaultCommissionRate",
            type: "uint64",
          },
          {
            components: [
              { internalType: "address", name: "source", type: "address" },
              { internalType: "uint64", name: "rate", type: "uint64" },
            ],
            internalType: "struct IStakingViewer.ProverCommissionInfo[]",
            name: "commissionRates",
            type: "tuple[]",
          },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "iconUrl", type: "string" },
        ],
        internalType: "struct IStakingViewer.ProverDisplayInfo[]",
        name: "proversInfo",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "getUserPortfolio",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "totalValue", type: "uint256" },
          { internalType: "uint256", name: "totalUnstaking", type: "uint256" },
          {
            internalType: "uint256",
            name: "totalReadyToWithdraw",
            type: "uint256",
          },
          {
            components: [
              { internalType: "address", name: "prover", type: "address" },
              { internalType: "uint256", name: "shares", type: "uint256" },
              {
                internalType: "uint256",
                name: "currentValue",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "totalUnstaking",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "readyToWithdraw",
                type: "uint256",
              },
              {
                components: [
                  { internalType: "uint256", name: "amount", type: "uint256" },
                  {
                    internalType: "uint256",
                    name: "requestTime",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "scaleSnapshot",
                    type: "uint256",
                  },
                ],
                internalType: "struct IStakingController.UnstakeRequest[]",
                name: "pendingRequests",
                type: "tuple[]",
              },
              { internalType: "bool", name: "isProver", type: "bool" },
            ],
            internalType: "struct IStakingViewer.UserStakeInfo[]",
            name: "stakes",
            type: "tuple[]",
          },
        ],
        internalType: "struct IStakingViewer.UserPortfolio",
        name: "portfolio",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "getUserReadyWithdrawals",
    outputs: [
      { internalType: "address[]", name: "provers", type: "address[]" },
      { internalType: "uint256[]", name: "amounts", type: "uint256[]" },
      { internalType: "uint256", name: "totalReady", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "user", type: "address" },
      { internalType: "address", name: "prover", type: "address" },
    ],
    name: "getUserStakeWithProver",
    outputs: [
      {
        components: [
          { internalType: "address", name: "prover", type: "address" },
          { internalType: "uint256", name: "shares", type: "uint256" },
          { internalType: "uint256", name: "currentValue", type: "uint256" },
          { internalType: "uint256", name: "totalUnstaking", type: "uint256" },
          { internalType: "uint256", name: "readyToWithdraw", type: "uint256" },
          {
            components: [
              { internalType: "uint256", name: "amount", type: "uint256" },
              { internalType: "uint256", name: "requestTime", type: "uint256" },
              {
                internalType: "uint256",
                name: "scaleSnapshot",
                type: "uint256",
              },
            ],
            internalType: "struct IStakingController.UnstakeRequest[]",
            name: "pendingRequests",
            type: "tuple[]",
          },
          { internalType: "bool", name: "isProver", type: "bool" },
        ],
        internalType: "struct IStakingViewer.UserStakeInfo",
        name: "stakeInfo",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "user", type: "address" },
      { internalType: "address[]", name: "provers", type: "address[]" },
    ],
    name: "getUserStakesWithProvers",
    outputs: [
      {
        components: [
          { internalType: "address", name: "prover", type: "address" },
          { internalType: "uint256", name: "shares", type: "uint256" },
          { internalType: "uint256", name: "currentValue", type: "uint256" },
          { internalType: "uint256", name: "totalUnstaking", type: "uint256" },
          { internalType: "uint256", name: "readyToWithdraw", type: "uint256" },
          {
            components: [
              { internalType: "uint256", name: "amount", type: "uint256" },
              { internalType: "uint256", name: "requestTime", type: "uint256" },
              {
                internalType: "uint256",
                name: "scaleSnapshot",
                type: "uint256",
              },
            ],
            internalType: "struct IStakingController.UnstakeRequest[]",
            name: "pendingRequests",
            type: "tuple[]",
          },
          { internalType: "bool", name: "isProver", type: "bool" },
        ],
        internalType: "struct IStakingViewer.UserStakeInfo[]",
        name: "stakesInfo",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingController",
    outputs: [
      {
        internalType: "contract IStakingController",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export const BrevisMarket_Contract_ABI = [
  {
    inputs: [
      {
        internalType: "contract IPicoVerifier",
        name: "_picoVerifier",
        type: "address",
      },
      {
        internalType: "contract IStakingController",
        name: "_stakingController",
        type: "address",
      },
      { internalType: "uint64", name: "_biddingPhaseDuration", type: "uint64" },
      { internalType: "uint64", name: "_revealPhaseDuration", type: "uint64" },
      { internalType: "uint256", name: "_minMaxFee", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "bytes32", name: "role", type: "bytes32" },
    ],
    name: "AccessControlAccountAlreadyHasRole",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "bytes32", name: "role", type: "bytes32" },
    ],
    name: "AccessControlAccountDoesNotHaveRole",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "bytes32", name: "role", type: "bytes32" },
    ],
    name: "AccessControlUnauthorizedAdmin",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "bytes32", name: "role", type: "bytes32" },
    ],
    name: "AccessControlUnauthorizedRole",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "currentTime", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
    ],
    name: "MarketBeforeDeadline",
    type: "error",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "expected", type: "bytes32" },
      { internalType: "bytes32", name: "actual", type: "bytes32" },
    ],
    name: "MarketBidRevealMismatch",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "currentTime", type: "uint256" },
      { internalType: "uint256", name: "biddingEndTime", type: "uint256" },
    ],
    name: "MarketBiddingPhaseEnded",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "currentTime", type: "uint256" },
      { internalType: "uint256", name: "biddingEndTime", type: "uint256" },
    ],
    name: "MarketBiddingPhaseNotEnded",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint64", name: "startAt", type: "uint64" },
      { internalType: "uint64", name: "currentTime", type: "uint64" },
    ],
    name: "MarketCannotPopStartedEpoch",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "currentTime", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint256", name: "biddingEndTime", type: "uint256" },
      { internalType: "uint256", name: "revealEndTime", type: "uint256" },
    ],
    name: "MarketCannotRefundYet",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "MarketCannotRegisterProverAsSubmitter",
    type: "error",
  },
  { inputs: [], name: "MarketCannotRegisterSelf", type: "error" },
  { inputs: [], name: "MarketDeadlineBeforeRevealPhaseEnd", type: "error" },
  { inputs: [], name: "MarketDeadlineMustBeInFuture", type: "error" },
  {
    inputs: [
      { internalType: "uint256", name: "currentTime", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
    ],
    name: "MarketDeadlinePassed",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint256", name: "maxAllowed", type: "uint256" },
    ],
    name: "MarketDeadlineTooFar",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "fee", type: "uint256" },
      { internalType: "uint256", name: "maxFee", type: "uint256" },
    ],
    name: "MarketFeeExceedsMaximum",
    type: "error",
  },
  { inputs: [], name: "MarketInvalidBps", type: "error" },
  {
    inputs: [
      {
        internalType: "enum IBrevisMarket.ReqStatus",
        name: "status",
        type: "uint8",
      },
    ],
    name: "MarketInvalidRequestStatus",
    type: "error",
  },
  { inputs: [], name: "MarketInvalidStakingController", type: "error" },
  {
    inputs: [
      { internalType: "uint64", name: "lastStartAt", type: "uint64" },
      { internalType: "uint64", name: "newStartAt", type: "uint64" },
    ],
    name: "MarketInvalidStatsEpochStart",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "provided", type: "uint256" },
      { internalType: "uint256", name: "maximum", type: "uint256" },
    ],
    name: "MarketMaxFeeTooHigh",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "provided", type: "uint256" },
      { internalType: "uint256", name: "minimum", type: "uint256" },
    ],
    name: "MarketMaxFeeTooLow",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "provided", type: "uint256" },
      { internalType: "uint256", name: "minimum", type: "uint256" },
    ],
    name: "MarketMinStakeTooLow",
    type: "error",
  },
  {
    inputs: [{ internalType: "bytes32", name: "reqid", type: "bytes32" }],
    name: "MarketNoAssignedProverToSlash",
    type: "error",
  },
  { inputs: [], name: "MarketNoFutureEpochToPop", type: "error" },
  { inputs: [], name: "MarketNoProtocolFeeToWithdraw", type: "error" },
  { inputs: [], name: "MarketNotAuthorized", type: "error" },
  {
    inputs: [
      { internalType: "address", name: "expected", type: "address" },
      { internalType: "address", name: "actual", type: "address" },
    ],
    name: "MarketNotExpectedProver",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "uint256", name: "requiredStake", type: "uint256" },
      { internalType: "uint256", name: "actualStake", type: "uint256" },
    ],
    name: "MarketProverNotEligible",
    type: "error",
  },
  { inputs: [], name: "MarketProverNotRegistered", type: "error" },
  {
    inputs: [{ internalType: "bytes32", name: "reqid", type: "bytes32" }],
    name: "MarketRequestAlreadyExists",
    type: "error",
  },
  {
    inputs: [{ internalType: "bytes32", name: "reqid", type: "bytes32" }],
    name: "MarketRequestNotFound",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "currentTime", type: "uint256" },
      { internalType: "uint256", name: "revealEndTime", type: "uint256" },
    ],
    name: "MarketRevealPhaseEnded",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "currentTime", type: "uint256" },
      { internalType: "uint256", name: "revealEndTime", type: "uint256" },
    ],
    name: "MarketRevealPhaseNotEnded",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "currentTime", type: "uint256" },
      { internalType: "uint256", name: "slashWindowEnd", type: "uint256" },
    ],
    name: "MarketSlashWindowExpired",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "submitter", type: "address" },
      { internalType: "address", name: "prover", type: "address" },
    ],
    name: "MarketSubmitterAlreadyRegistered",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "submitter", type: "address" }],
    name: "MarketSubmitterConsentRequired",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "submitter", type: "address" }],
    name: "MarketSubmitterNotRegistered",
    type: "error",
  },
  { inputs: [], name: "MarketZeroAddress", type: "error" },
  {
    inputs: [
      { internalType: "address", name: "currentOwner", type: "address" },
    ],
    name: "OwnerAlreadySet",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "caller", type: "address" },
      { internalType: "address", name: "owner", type: "address" },
    ],
    name: "OwnerUnauthorized",
    type: "error",
  },
  { inputs: [], name: "OwnerZeroAddress", type: "error" },
  { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
  {
    inputs: [{ internalType: "address", name: "token", type: "address" }],
    name: "SafeERC20FailedOperation",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "reqid",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      { indexed: false, internalType: "uint256", name: "fee", type: "uint256" },
    ],
    name: "BidRevealed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "oldDuration",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "newDuration",
        type: "uint64",
      },
    ],
    name: "BiddingPhaseDurationUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldToken",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newToken",
        type: "address",
      },
    ],
    name: "FeeTokenUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "MaxMaxFeeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "MinMaxFeeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "reqid",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "bidHash",
        type: "bytes32",
      },
    ],
    name: "NewBid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "reqid",
        type: "bytes32",
      },
      {
        components: [
          { internalType: "uint64", name: "nonce", type: "uint64" },
          { internalType: "bytes32", name: "vk", type: "bytes32" },
          {
            internalType: "bytes32",
            name: "publicValuesDigest",
            type: "bytes32",
          },
          { internalType: "string", name: "imgURL", type: "string" },
          { internalType: "bytes", name: "inputData", type: "bytes" },
          { internalType: "string", name: "inputURL", type: "string" },
          {
            components: [
              { internalType: "uint256", name: "maxFee", type: "uint256" },
              { internalType: "uint256", name: "minStake", type: "uint256" },
              { internalType: "uint64", name: "deadline", type: "uint64" },
            ],
            internalType: "struct IBrevisMarket.FeeParams",
            name: "fee",
            type: "tuple",
          },
        ],
        indexed: false,
        internalType: "struct IBrevisMarket.ProofRequest",
        name: "req",
        type: "tuple",
      },
    ],
    name: "NewRequest",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldBps",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBps",
        type: "uint256",
      },
    ],
    name: "OvercommitBpsUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldVerifier",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newVerifier",
        type: "address",
      },
    ],
    name: "PicoVerifierUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "reqid",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[8]",
        name: "proof",
        type: "uint256[8]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "actualFee",
        type: "uint256",
      },
    ],
    name: "ProofSubmitted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldBps",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBps",
        type: "uint256",
      },
    ],
    name: "ProtocolFeeBpsUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ProtocolFeeWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "reqid",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "slashAmount",
        type: "uint256",
      },
    ],
    name: "ProverSlashed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "reqid",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "requester",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Refunded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "oldDuration",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "newDuration",
        type: "uint64",
      },
    ],
    name: "RevealPhaseDurationUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
      {
        indexed: true,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldBps",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBps",
        type: "uint256",
      },
    ],
    name: "SlashBpsUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldWindow",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newWindow",
        type: "uint256",
      },
    ],
    name: "SlashWindowUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "poppedStartAt",
        type: "uint64",
      },
    ],
    name: "StatsEpochPopped",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "scheduledStartAt",
        type: "uint64",
      },
    ],
    name: "StatsEpochScheduled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "newEpochId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "statsStartAt",
        type: "uint64",
      },
    ],
    name: "StatsReset",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "submitter",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "oldProver",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newProver",
        type: "address",
      },
    ],
    name: "SubmitterConsentUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "submitter",
        type: "address",
      },
    ],
    name: "SubmitterRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "submitter",
        type: "address",
      },
    ],
    name: "SubmitterUnregistered",
    type: "event",
  },
  {
    inputs: [],
    name: "BPS_DENOMINATOR",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_DEADLINE_DURATION",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "assignedStake",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "reqid", type: "bytes32" },
      { internalType: "bytes32", name: "bidHash", type: "bytes32" },
    ],
    name: "bid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "biddingPhaseDuration",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cancelOwnershipTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "feeToken",
    outputs: [{ internalType: "contract IERC20", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "reqid", type: "bytes32" },
      { internalType: "address", name: "prover", type: "address" },
    ],
    name: "getBidHash",
    outputs: [{ internalType: "bytes32", name: "bidHash", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "reqid", type: "bytes32" }],
    name: "getBidders",
    outputs: [
      { internalType: "address", name: "winner", type: "address" },
      { internalType: "uint256", name: "winnerFee", type: "uint256" },
      { internalType: "address", name: "secondPlace", type: "address" },
      { internalType: "uint256", name: "secondFee", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getGlobalRecentStats",
    outputs: [
      {
        components: [
          { internalType: "uint64", name: "totalRequests", type: "uint64" },
          { internalType: "uint64", name: "totalFulfilled", type: "uint64" },
          { internalType: "uint256", name: "totalFees", type: "uint256" },
        ],
        internalType: "struct IBrevisMarket.GlobalStats",
        name: "stats",
        type: "tuple",
      },
      { internalType: "uint64", name: "startAt", type: "uint64" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint64", name: "epochId", type: "uint64" }],
    name: "getGlobalStatsForStatsEpoch",
    outputs: [
      {
        components: [
          { internalType: "uint64", name: "totalRequests", type: "uint64" },
          { internalType: "uint64", name: "totalFulfilled", type: "uint64" },
          { internalType: "uint256", name: "totalFees", type: "uint256" },
        ],
        internalType: "struct IBrevisMarket.GlobalStats",
        name: "stats",
        type: "tuple",
      },
      { internalType: "uint64", name: "startAt", type: "uint64" },
      { internalType: "uint64", name: "endAt", type: "uint64" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getGlobalStatsTotal",
    outputs: [
      {
        components: [
          { internalType: "uint64", name: "totalRequests", type: "uint64" },
          { internalType: "uint64", name: "totalFulfilled", type: "uint64" },
          { internalType: "uint256", name: "totalFees", type: "uint256" },
        ],
        internalType: "struct IBrevisMarket.GlobalStats",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "reqid", type: "bytes32" }],
    name: "getProof",
    outputs: [
      { internalType: "uint256[8]", name: "proof", type: "uint256[8]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getProtocolFeeInfo",
    outputs: [
      { internalType: "uint256", name: "feeBps", type: "uint256" },
      { internalType: "uint256", name: "balance", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverPendingRequests",
    outputs: [{ internalType: "bytes32[]", name: "reqids", type: "bytes32[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverRecentStats",
    outputs: [
      {
        components: [
          { internalType: "uint64", name: "bids", type: "uint64" },
          { internalType: "uint64", name: "reveals", type: "uint64" },
          { internalType: "uint64", name: "requestsFulfilled", type: "uint64" },
          { internalType: "uint64", name: "requestsRefunded", type: "uint64" },
          { internalType: "uint64", name: "lastActiveAt", type: "uint64" },
          { internalType: "uint256", name: "feeReceived", type: "uint256" },
        ],
        internalType: "struct IBrevisMarket.ProverStats",
        name: "stats",
        type: "tuple",
      },
      { internalType: "uint64", name: "startAt", type: "uint64" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "uint64", name: "epochId", type: "uint64" },
    ],
    name: "getProverStatsForStatsEpoch",
    outputs: [
      {
        components: [
          { internalType: "uint64", name: "bids", type: "uint64" },
          { internalType: "uint64", name: "reveals", type: "uint64" },
          { internalType: "uint64", name: "requestsFulfilled", type: "uint64" },
          { internalType: "uint64", name: "requestsRefunded", type: "uint64" },
          { internalType: "uint64", name: "lastActiveAt", type: "uint64" },
          { internalType: "uint256", name: "feeReceived", type: "uint256" },
        ],
        internalType: "struct IBrevisMarket.ProverStats",
        name: "stats",
        type: "tuple",
      },
      { internalType: "uint64", name: "startAt", type: "uint64" },
      { internalType: "uint64", name: "endAt", type: "uint64" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverStatsTotal",
    outputs: [
      {
        components: [
          { internalType: "uint64", name: "bids", type: "uint64" },
          { internalType: "uint64", name: "reveals", type: "uint64" },
          { internalType: "uint64", name: "requestsFulfilled", type: "uint64" },
          { internalType: "uint64", name: "requestsRefunded", type: "uint64" },
          { internalType: "uint64", name: "lastActiveAt", type: "uint64" },
          { internalType: "uint256", name: "feeReceived", type: "uint256" },
        ],
        internalType: "struct IBrevisMarket.ProverStats",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRecentStatsInfo",
    outputs: [
      { internalType: "uint64", name: "startAt", type: "uint64" },
      { internalType: "uint64", name: "epochId", type: "uint64" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "reqid", type: "bytes32" }],
    name: "getRequest",
    outputs: [
      {
        internalType: "enum IBrevisMarket.ReqStatus",
        name: "status",
        type: "uint8",
      },
      { internalType: "uint64", name: "timestamp", type: "uint64" },
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "uint256", name: "maxFee", type: "uint256" },
      { internalType: "uint256", name: "minStake", type: "uint256" },
      { internalType: "uint64", name: "deadline", type: "uint64" },
      { internalType: "bytes32", name: "vk", type: "bytes32" },
      { internalType: "bytes32", name: "publicValuesDigest", type: "bytes32" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "getSenderPendingRequests",
    outputs: [{ internalType: "bytes32[]", name: "reqids", type: "bytes32[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getSubmittersForProver",
    outputs: [
      { internalType: "address[]", name: "submitters", type: "address[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    name: "globalStats",
    outputs: [
      { internalType: "uint64", name: "totalRequests", type: "uint64" },
      { internalType: "uint64", name: "totalFulfilled", type: "uint64" },
      { internalType: "uint256", name: "totalFees", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address[]", name: "accounts", type: "address[]" },
    ],
    name: "grantRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "hasRole",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPicoVerifier",
        name: "_picoVerifier",
        type: "address",
      },
      {
        internalType: "contract IStakingController",
        name: "_stakingController",
        type: "address",
      },
      { internalType: "uint64", name: "_biddingPhaseDuration", type: "uint64" },
      { internalType: "uint64", name: "_revealPhaseDuration", type: "uint64" },
      { internalType: "uint256", name: "_minMaxFee", type: "uint256" },
    ],
    name: "init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "maxMaxFee",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minMaxFee",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "overcommitBps",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "picoVerifier",
    outputs: [
      { internalType: "contract IPicoVerifier", name: "", type: "address" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "popStatsEpoch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "protocolFeeBalance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "protocolFeeBps",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint64", name: "", type: "uint64" },
    ],
    name: "proverStats",
    outputs: [
      { internalType: "uint64", name: "bids", type: "uint64" },
      { internalType: "uint64", name: "reveals", type: "uint64" },
      { internalType: "uint64", name: "requestsFulfilled", type: "uint64" },
      { internalType: "uint64", name: "requestsRefunded", type: "uint64" },
      { internalType: "uint64", name: "lastActiveAt", type: "uint64" },
      { internalType: "uint256", name: "feeReceived", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "reqid", type: "bytes32" }],
    name: "refund",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "submitter", type: "address" }],
    name: "registerSubmitter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "submitters", type: "address[]" },
    ],
    name: "registerSubmitters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "role", type: "bytes32" }],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint64", name: "nonce", type: "uint64" },
          { internalType: "bytes32", name: "vk", type: "bytes32" },
          {
            internalType: "bytes32",
            name: "publicValuesDigest",
            type: "bytes32",
          },
          { internalType: "string", name: "imgURL", type: "string" },
          { internalType: "bytes", name: "inputData", type: "bytes" },
          { internalType: "string", name: "inputURL", type: "string" },
          {
            components: [
              { internalType: "uint256", name: "maxFee", type: "uint256" },
              { internalType: "uint256", name: "minStake", type: "uint256" },
              { internalType: "uint64", name: "deadline", type: "uint64" },
            ],
            internalType: "struct IBrevisMarket.FeeParams",
            name: "fee",
            type: "tuple",
          },
        ],
        internalType: "struct IBrevisMarket.ProofRequest",
        name: "req",
        type: "tuple",
      },
    ],
    name: "requestProof",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    name: "requests",
    outputs: [
      {
        internalType: "enum IBrevisMarket.ReqStatus",
        name: "status",
        type: "uint8",
      },
      { internalType: "uint64", name: "timestamp", type: "uint64" },
      { internalType: "address", name: "sender", type: "address" },
      {
        components: [
          { internalType: "uint256", name: "maxFee", type: "uint256" },
          { internalType: "uint256", name: "minStake", type: "uint256" },
          { internalType: "uint64", name: "deadline", type: "uint64" },
        ],
        internalType: "struct IBrevisMarket.FeeParams",
        name: "fee",
        type: "tuple",
      },
      { internalType: "bytes32", name: "vk", type: "bytes32" },
      { internalType: "bytes32", name: "publicValuesDigest", type: "bytes32" },
      { internalType: "uint64", name: "bidCount", type: "uint64" },
      {
        components: [
          { internalType: "address", name: "prover", type: "address" },
          { internalType: "uint256", name: "fee", type: "uint256" },
        ],
        internalType: "struct IBrevisMarket.Bidder",
        name: "winner",
        type: "tuple",
      },
      {
        components: [
          { internalType: "address", name: "prover", type: "address" },
          { internalType: "uint256", name: "fee", type: "uint256" },
        ],
        internalType: "struct IBrevisMarket.Bidder",
        name: "second",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "reqid", type: "bytes32" },
      { internalType: "uint256", name: "fee", type: "uint256" },
      { internalType: "uint256", name: "nonce", type: "uint256" },
    ],
    name: "reveal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "revealPhaseDuration",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address[]", name: "accounts", type: "address[]" },
    ],
    name: "revokeRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "role", type: "bytes32" }],
    name: "roleAdmin",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "role", type: "bytes32" }],
    name: "roleMemberCount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "role", type: "bytes32" }],
    name: "roleMembers",
    outputs: [
      { internalType: "address[]", name: "accounts", type: "address[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint64", name: "startAt", type: "uint64" }],
    name: "scheduleStatsEpoch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint64", name: "newDuration", type: "uint64" }],
    name: "setBiddingPhaseDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "newMaxFee", type: "uint256" }],
    name: "setMaxMaxFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "newMinFee", type: "uint256" }],
    name: "setMinMaxFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "newBps", type: "uint256" }],
    name: "setOvercommitBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPicoVerifier",
        name: "newVerifier",
        type: "address",
      },
    ],
    name: "setPicoVerifier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "newBps", type: "uint256" }],
    name: "setProtocolFeeBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint64", name: "newDuration", type: "uint64" }],
    name: "setRevealPhaseDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "admin", type: "address" },
    ],
    name: "setRoleAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "newBps", type: "uint256" }],
    name: "setSlashBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "newWindow", type: "uint256" }],
    name: "setSlashWindow",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "setSubmitterConsent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "reqid", type: "bytes32" }],
    name: "slash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "slashBps",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "slashWindow",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingController",
    outputs: [
      {
        internalType: "contract IStakingController",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "startOwnershipTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "statsEpochId",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "statsEpochs",
    outputs: [
      { internalType: "uint64", name: "startAt", type: "uint64" },
      { internalType: "uint64", name: "endAt", type: "uint64" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "statsEpochsLength",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "reqid", type: "bytes32" },
      { internalType: "uint256[8]", name: "proof", type: "uint256[8]" },
    ],
    name: "submitProof",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "submitter", type: "address" }],
    name: "submitterConsent",
    outputs: [{ internalType: "address", name: "prover", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "submitter", type: "address" }],
    name: "submitterToProver",
    outputs: [{ internalType: "address", name: "prover", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "submitter", type: "address" }],
    name: "unregisterSubmitter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unregisterSubmitter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "submitters", type: "address[]" },
    ],
    name: "unregisterSubmitters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "to", type: "address" }],
    name: "withdrawProtocolFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export const MarketViewer_Contract_ABI = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_brevisMarketAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "reqid", type: "bytes32" },
      { internalType: "address[]", name: "provers", type: "address[]" },
    ],
    name: "batchGetBidHashes",
    outputs: [
      { internalType: "bytes32[]", name: "bidHashes", type: "bytes32[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32[]", name: "reqids", type: "bytes32[]" }],
    name: "batchGetBidders",
    outputs: [
      {
        components: [
          { internalType: "bytes32", name: "reqid", type: "bytes32" },
          { internalType: "address", name: "winner", type: "address" },
          { internalType: "uint256", name: "winnerFee", type: "uint256" },
          { internalType: "address", name: "second", type: "address" },
          { internalType: "uint256", name: "secondFee", type: "uint256" },
        ],
        internalType: "struct IMarketViewer.BiddersView[]",
        name: "out",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32[]", name: "reqids", type: "bytes32[]" }],
    name: "batchGetProofs",
    outputs: [
      { internalType: "uint256[8][]", name: "proofs", type: "uint256[8][]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address[]", name: "provers", type: "address[]" }],
    name: "batchGetProverStatsComposite",
    outputs: [
      {
        components: [
          {
            components: [
              { internalType: "uint64", name: "bids", type: "uint64" },
              { internalType: "uint64", name: "reveals", type: "uint64" },
              {
                internalType: "uint64",
                name: "requestsFulfilled",
                type: "uint64",
              },
              {
                internalType: "uint64",
                name: "requestsRefunded",
                type: "uint64",
              },
              { internalType: "uint64", name: "lastActiveAt", type: "uint64" },
              { internalType: "uint256", name: "feeReceived", type: "uint256" },
            ],
            internalType: "struct IBrevisMarket.ProverStats",
            name: "total",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint64", name: "bids", type: "uint64" },
              { internalType: "uint64", name: "reveals", type: "uint64" },
              {
                internalType: "uint64",
                name: "requestsFulfilled",
                type: "uint64",
              },
              {
                internalType: "uint64",
                name: "requestsRefunded",
                type: "uint64",
              },
              { internalType: "uint64", name: "lastActiveAt", type: "uint64" },
              { internalType: "uint256", name: "feeReceived", type: "uint256" },
            ],
            internalType: "struct IBrevisMarket.ProverStats",
            name: "recent",
            type: "tuple",
          },
          { internalType: "uint64", name: "recentStartAt", type: "uint64" },
          { internalType: "uint64", name: "successRateBps", type: "uint64" },
          { internalType: "uint64", name: "fulfilled", type: "uint64" },
          { internalType: "uint64", name: "refunded", type: "uint64" },
          { internalType: "uint64", name: "pendingCount", type: "uint64" },
          { internalType: "uint64", name: "overdueCount", type: "uint64" },
        ],
        internalType: "struct IMarketViewer.ProverStatsComposite[]",
        name: "out",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32[]", name: "reqids", type: "bytes32[]" }],
    name: "batchGetRequests",
    outputs: [
      {
        components: [
          { internalType: "bytes32", name: "reqid", type: "bytes32" },
          {
            internalType: "enum IBrevisMarket.ReqStatus",
            name: "status",
            type: "uint8",
          },
          { internalType: "uint64", name: "timestamp", type: "uint64" },
          { internalType: "address", name: "sender", type: "address" },
          { internalType: "uint256", name: "maxFee", type: "uint256" },
          { internalType: "uint256", name: "minStake", type: "uint256" },
          { internalType: "uint64", name: "deadline", type: "uint64" },
          { internalType: "bytes32", name: "vk", type: "bytes32" },
          {
            internalType: "bytes32",
            name: "publicValuesDigest",
            type: "bytes32",
          },
        ],
        internalType: "struct IMarketViewer.RequestView[]",
        name: "out",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "brevisMarket",
    outputs: [
      { internalType: "contract IBrevisMarket", name: "", type: "address" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getGlobalStatsComposite",
    outputs: [
      {
        components: [
          {
            components: [
              { internalType: "uint64", name: "totalRequests", type: "uint64" },
              {
                internalType: "uint64",
                name: "totalFulfilled",
                type: "uint64",
              },
              { internalType: "uint256", name: "totalFees", type: "uint256" },
            ],
            internalType: "struct IBrevisMarket.GlobalStats",
            name: "total",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint64", name: "totalRequests", type: "uint64" },
              {
                internalType: "uint64",
                name: "totalFulfilled",
                type: "uint64",
              },
              { internalType: "uint256", name: "totalFees", type: "uint256" },
            ],
            internalType: "struct IBrevisMarket.GlobalStats",
            name: "recent",
            type: "tuple",
          },
          { internalType: "uint64", name: "recentStartAt", type: "uint64" },
        ],
        internalType: "struct IMarketViewer.GlobalStatsComposite",
        name: "v",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverOverdueCount",
    outputs: [{ internalType: "uint64", name: "overdue", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverOverdueRequests",
    outputs: [{ internalType: "bytes32[]", name: "reqids", type: "bytes32[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverPendingCount",
    outputs: [{ internalType: "uint64", name: "count", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "bytes32[]", name: "reqids", type: "bytes32[]" },
    ],
    name: "getProverPendingRequests",
    outputs: [
      {
        components: [
          { internalType: "bytes32", name: "reqid", type: "bytes32" },
          { internalType: "uint64", name: "deadline", type: "uint64" },
          {
            internalType: "enum IBrevisMarket.ReqStatus",
            name: "status",
            type: "uint8",
          },
          { internalType: "address", name: "winner", type: "address" },
          { internalType: "bool", name: "isOverdue", type: "bool" },
        ],
        internalType: "struct IMarketViewer.PendingItemView[]",
        name: "items",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverPendingRequests",
    outputs: [
      {
        components: [
          { internalType: "bytes32", name: "reqid", type: "bytes32" },
          { internalType: "uint64", name: "deadline", type: "uint64" },
          {
            internalType: "enum IBrevisMarket.ReqStatus",
            name: "status",
            type: "uint8",
          },
          { internalType: "address", name: "winner", type: "address" },
          { internalType: "bool", name: "isOverdue", type: "bool" },
        ],
        internalType: "struct IMarketViewer.PendingItemView[]",
        name: "items",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverStatsComposite",
    outputs: [
      {
        components: [
          {
            components: [
              { internalType: "uint64", name: "bids", type: "uint64" },
              { internalType: "uint64", name: "reveals", type: "uint64" },
              {
                internalType: "uint64",
                name: "requestsFulfilled",
                type: "uint64",
              },
              {
                internalType: "uint64",
                name: "requestsRefunded",
                type: "uint64",
              },
              { internalType: "uint64", name: "lastActiveAt", type: "uint64" },
              { internalType: "uint256", name: "feeReceived", type: "uint256" },
            ],
            internalType: "struct IBrevisMarket.ProverStats",
            name: "total",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint64", name: "bids", type: "uint64" },
              { internalType: "uint64", name: "reveals", type: "uint64" },
              {
                internalType: "uint64",
                name: "requestsFulfilled",
                type: "uint64",
              },
              {
                internalType: "uint64",
                name: "requestsRefunded",
                type: "uint64",
              },
              { internalType: "uint64", name: "lastActiveAt", type: "uint64" },
              { internalType: "uint256", name: "feeReceived", type: "uint256" },
            ],
            internalType: "struct IBrevisMarket.ProverStats",
            name: "recent",
            type: "tuple",
          },
          { internalType: "uint64", name: "recentStartAt", type: "uint64" },
          { internalType: "uint64", name: "successRateBps", type: "uint64" },
          { internalType: "uint64", name: "fulfilled", type: "uint64" },
          { internalType: "uint64", name: "refunded", type: "uint64" },
          { internalType: "uint64", name: "pendingCount", type: "uint64" },
          { internalType: "uint64", name: "overdueCount", type: "uint64" },
        ],
        internalType: "struct IMarketViewer.ProverStatsComposite",
        name: "v",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "getSenderOverdueCount",
    outputs: [{ internalType: "uint64", name: "overdue", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "getSenderOverdueRequests",
    outputs: [{ internalType: "bytes32[]", name: "reqids", type: "bytes32[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "getSenderPendingCount",
    outputs: [{ internalType: "uint64", name: "count", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "bytes32[]", name: "reqids", type: "bytes32[]" },
    ],
    name: "getSenderPendingRequests",
    outputs: [
      {
        components: [
          { internalType: "bytes32", name: "reqid", type: "bytes32" },
          { internalType: "uint64", name: "deadline", type: "uint64" },
          {
            internalType: "enum IBrevisMarket.ReqStatus",
            name: "status",
            type: "uint8",
          },
          { internalType: "address", name: "winner", type: "address" },
          { internalType: "bool", name: "isOverdue", type: "bool" },
        ],
        internalType: "struct IMarketViewer.PendingItemView[]",
        name: "items",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "getSenderPendingRequests",
    outputs: [
      {
        components: [
          { internalType: "bytes32", name: "reqid", type: "bytes32" },
          { internalType: "uint64", name: "deadline", type: "uint64" },
          {
            internalType: "enum IBrevisMarket.ReqStatus",
            name: "status",
            type: "uint8",
          },
          { internalType: "address", name: "winner", type: "address" },
          { internalType: "bool", name: "isOverdue", type: "bool" },
        ],
        internalType: "struct IMarketViewer.PendingItemView[]",
        name: "items",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint64[]", name: "epochIds", type: "uint64[]" }],
    name: "getStatsEpochs",
    outputs: [
      { internalType: "uint64[]", name: "startAts", type: "uint64[]" },
      { internalType: "uint64[]", name: "endAts", type: "uint64[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStatsEpochs",
    outputs: [
      { internalType: "uint64[]", name: "startAts", type: "uint64[]" },
      { internalType: "uint64[]", name: "endAts", type: "uint64[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export const StakingController_Contract_ABI = [
  {
    inputs: [
      { internalType: "address", name: "_stakingToken", type: "address" },
      { internalType: "address", name: "_vaultFactory", type: "address" },
      { internalType: "uint256", name: "_unstakeDelay", type: "uint256" },
      { internalType: "uint256", name: "_minSelfStake", type: "uint256" },
      { internalType: "uint256", name: "_maxSlashBps", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "bytes32", name: "role", type: "bytes32" },
    ],
    name: "AccessControlAccountAlreadyHasRole",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "bytes32", name: "role", type: "bytes32" },
    ],
    name: "AccessControlAccountDoesNotHaveRole",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "bytes32", name: "role", type: "bytes32" },
    ],
    name: "AccessControlUnauthorizedAdmin",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "bytes32", name: "role", type: "bytes32" },
    ],
    name: "AccessControlUnauthorizedRole",
    type: "error",
  },
  {
    inputs: [],
    name: "ControllerCannotRetireProverWithPendingCommission",
    type: "error",
  },
  {
    inputs: [],
    name: "ControllerCannotRetireProverWithPendingUnstakes",
    type: "error",
  },
  {
    inputs: [],
    name: "ControllerCannotRetireProverWithStakers",
    type: "error",
  },
  { inputs: [], name: "ControllerInsufficientShares", type: "error" },
  { inputs: [], name: "ControllerInsufficientTreasury", type: "error" },
  { inputs: [], name: "ControllerInvalidArg", type: "error" },
  { inputs: [], name: "ControllerInvalidStakeAmount", type: "error" },
  { inputs: [], name: "ControllerInvalidUnstakeAmount", type: "error" },
  { inputs: [], name: "ControllerMinSelfStakeNotMet", type: "error" },
  { inputs: [], name: "ControllerNoShares", type: "error" },
  { inputs: [], name: "ControllerNoUnstakeRequest", type: "error" },
  { inputs: [], name: "ControllerNotAuthorized", type: "error" },
  { inputs: [], name: "ControllerOnlyAdmin", type: "error" },
  { inputs: [], name: "ControllerOnlyAdminOrProver", type: "error" },
  { inputs: [], name: "ControllerOnlyProver", type: "error" },
  { inputs: [], name: "ControllerOnlyVault", type: "error" },
  { inputs: [], name: "ControllerProverAlreadyInitialized", type: "error" },
  { inputs: [], name: "ControllerProverNotActive", type: "error" },
  { inputs: [], name: "ControllerProverNotInitialized", type: "error" },
  { inputs: [], name: "ControllerShareAccountingMismatch", type: "error" },
  { inputs: [], name: "ControllerSlashTooHigh", type: "error" },
  { inputs: [], name: "ControllerTooManyPendingUnstakes", type: "error" },
  { inputs: [], name: "ControllerUnstakeNotReady", type: "error" },
  { inputs: [], name: "ControllerZeroAmount", type: "error" },
  { inputs: [], name: "EnforcedPause", type: "error" },
  { inputs: [], name: "ExpectedPause", type: "error" },
  {
    inputs: [
      { internalType: "address", name: "currentOwner", type: "address" },
    ],
    name: "OwnerAlreadySet",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "caller", type: "address" },
      { internalType: "address", name: "owner", type: "address" },
    ],
    name: "OwnerUnauthorized",
    type: "error",
  },
  { inputs: [], name: "OwnerZeroAddress", type: "error" },
  {
    inputs: [{ internalType: "address", name: "caller", type: "address" }],
    name: "PauserUnauthorized",
    type: "error",
  },
  { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
  {
    inputs: [{ internalType: "address", name: "token", type: "address" }],
    name: "SafeERC20FailedOperation",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "CommissionClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "source",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "oldRate",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "newRate",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "useDefault",
        type: "bool",
      },
    ],
    name: "CommissionRateUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "EmergencyRecovered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldValue",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newValue",
        type: "uint256",
      },
    ],
    name: "MaxSlashBpsUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldValue",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newValue",
        type: "uint256",
      },
    ],
    name: "MinSelfStakeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "vault",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "defaultCommissionRate",
        type: "uint64",
      },
    ],
    name: "ProverInitialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      { indexed: false, internalType: "string", name: "name", type: "string" },
      {
        indexed: false,
        internalType: "string",
        name: "iconUrl",
        type: "string",
      },
    ],
    name: "ProverProfileUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
    ],
    name: "ProverRetired",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      { indexed: false, internalType: "uint256", name: "bps", type: "uint256" },
    ],
    name: "ProverSlashed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum IStakingController.ProverState",
        name: "oldState",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "enum IStakingController.ProverState",
        name: "newState",
        type: "uint8",
      },
    ],
    name: "ProverStateChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "bool", name: "required", type: "bool" },
    ],
    name: "RequireAuthorizationUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "source",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "commission",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toStakers",
        type: "uint256",
      },
    ],
    name: "RewardsAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
      {
        indexed: true,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TreasuryWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UnstakeCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldDelay",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newDelay",
        type: "uint256",
      },
    ],
    name: "UnstakeDelayUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prover",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UnstakeRequested",
    type: "event",
  },
  {
    inputs: [],
    name: "AUTHORIZED_PROVER_ROLE",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BPS_DENOMINATOR",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEACTIVATION_SCALE",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_PENDING_UNSTAKES",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_SCALE_FLOOR",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SLASHER_ROLE",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "provers", type: "address[]" },
      { internalType: "uint256[]", name: "amounts", type: "uint256[]" },
    ],
    name: "addRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "addRewards",
    outputs: [
      { internalType: "uint256", name: "commission", type: "uint256" },
      { internalType: "uint256", name: "toStakers", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "from", type: "address" },
      { internalType: "uint256", name: "shares", type: "uint256" },
    ],
    name: "beforeShareTransfer",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cancelOwnershipTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimCommission",
    outputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "completeUnstake",
    outputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "deactivateProver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address[]", name: "provers", type: "address[]" }],
    name: "deactivateProvers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "emergencyRecover",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "source", type: "address" },
    ],
    name: "getCommissionRate",
    outputs: [{ internalType: "uint64", name: "rate", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getCommissionRates",
    outputs: [
      { internalType: "address[]", name: "sources", type: "address[]" },
      { internalType: "uint64[]", name: "rates", type: "uint64[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "staker", type: "address" },
    ],
    name: "getPendingUnstakes",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "amount", type: "uint256" },
          { internalType: "uint256", name: "requestTime", type: "uint256" },
          { internalType: "uint256", name: "scaleSnapshot", type: "uint256" },
        ],
        internalType: "struct IStakingController.UnstakeRequest[]",
        name: "requests",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bool", name: "isActive", type: "bool" }],
    name: "getProverCount",
    outputs: [{ internalType: "uint256", name: "count", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverInfo",
    outputs: [
      {
        internalType: "enum IStakingController.ProverState",
        name: "state",
        type: "uint8",
      },
      { internalType: "address", name: "vault", type: "address" },
      { internalType: "uint64", name: "defaultCommissionRate", type: "uint64" },
      { internalType: "uint256", name: "pendingCommission", type: "uint256" },
      { internalType: "uint256", name: "numStakers", type: "uint256" },
      { internalType: "uint64", name: "joinedAt", type: "uint64" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "string", name: "iconUrl", type: "string" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverSlashingScale",
    outputs: [{ internalType: "uint256", name: "scale", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverStakers",
    outputs: [
      { internalType: "address[]", name: "stakers", type: "address[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverState",
    outputs: [
      {
        internalType: "enum IStakingController.ProverState",
        name: "state",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverTotalAssets",
    outputs: [
      { internalType: "uint256", name: "totalAssets", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverTotalUnstaking",
    outputs: [
      { internalType: "uint256", name: "totalAmount", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getProverVault",
    outputs: [{ internalType: "address", name: "vault", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bool", name: "isActive", type: "bool" },
      { internalType: "uint256", name: "start", type: "uint256" },
      { internalType: "uint256", name: "end", type: "uint256" },
    ],
    name: "getProvers",
    outputs: [
      { internalType: "address[]", name: "provers", type: "address[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "staker", type: "address" },
    ],
    name: "getStakeInfo",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getStakersWithPendingUnstakes",
    outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "getStakersWithPendingUnstakesCount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bool", name: "isActive", type: "bool" }],
    name: "getTotalVaultAssets",
    outputs: [
      { internalType: "uint256", name: "totalAssets", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "staker", type: "address" },
    ],
    name: "getUnstakingInfo",
    outputs: [
      { internalType: "uint256", name: "totalAmount", type: "uint256" },
      { internalType: "uint256", name: "readyAmount", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address[]", name: "accounts", type: "address[]" },
    ],
    name: "grantRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "hasRole",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_stakingToken", type: "address" },
      { internalType: "address", name: "_vaultFactory", type: "address" },
      { internalType: "uint256", name: "_unstakeDelay", type: "uint256" },
      { internalType: "uint256", name: "_minSelfStake", type: "uint256" },
      { internalType: "uint256", name: "_maxSlashBps", type: "uint256" },
    ],
    name: "init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint64", name: "defaultCommissionRate", type: "uint64" },
    ],
    name: "initializeProver",
    outputs: [{ internalType: "address", name: "vault", type: "address" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "uint256", name: "minimumVaultAssets", type: "uint256" },
    ],
    name: "isProverEligible",
    outputs: [
      { internalType: "bool", name: "eligible", type: "bool" },
      { internalType: "uint256", name: "currentVaultAssets", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "jailProver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address[]", name: "provers", type: "address[]" }],
    name: "jailProvers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "receiver", type: "address" },
    ],
    name: "maxDeposit",
    outputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "receiver", type: "address" },
    ],
    name: "maxMint",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "owner", type: "address" },
    ],
    name: "maxRedeem",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSlashBps",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "owner", type: "address" },
    ],
    name: "maxWithdraw",
    outputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minSelfStake",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "shares", type: "uint256" },
    ],
    name: "onShareTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "reactivateProver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address[]", name: "provers", type: "address[]" }],
    name: "reactivateProvers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "role", type: "bytes32" }],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "uint256", name: "shares", type: "uint256" },
    ],
    name: "requestUnstake",
    outputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "requireAuthorization",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "source", type: "address" }],
    name: "resetCommissionRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "prover", type: "address" }],
    name: "retireProver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address[]", name: "provers", type: "address[]" }],
    name: "retireProvers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address[]", name: "accounts", type: "address[]" },
    ],
    name: "revokeRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "role", type: "bytes32" }],
    name: "roleAdmin",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "role", type: "bytes32" }],
    name: "roleMemberCount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "role", type: "bytes32" }],
    name: "roleMembers",
    outputs: [
      { internalType: "address[]", name: "accounts", type: "address[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "source", type: "address" },
      { internalType: "uint64", name: "newRate", type: "uint64" },
    ],
    name: "setCommissionRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "value", type: "uint256" }],
    name: "setMaxSlashBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "value", type: "uint256" }],
    name: "setMinSelfStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "name", type: "string" },
      { internalType: "string", name: "iconUrl", type: "string" },
    ],
    name: "setProverProfile",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "string", name: "iconUrl", type: "string" },
    ],
    name: "setProverProfileByAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bool", name: "required", type: "bool" }],
    name: "setRequireAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "admin", type: "address" },
    ],
    name: "setRoleAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "newDelay", type: "uint256" }],
    name: "setUnstakeDelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "uint256", name: "bps", type: "uint256" },
    ],
    name: "slash",
    outputs: [
      { internalType: "uint256", name: "slashedAmount", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "slashByAmount",
    outputs: [
      { internalType: "uint256", name: "slashedAmount", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "stake",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "prover", type: "address" },
      { internalType: "address", name: "staker", type: "address" },
    ],
    name: "stakerHasPendingUnstakes",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingToken",
    outputs: [{ internalType: "contract IERC20", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "startOwnershipTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalUnstaking",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "treasuryPool",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unstakeDelay",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vaultFactory",
    outputs: [
      { internalType: "contract IVaultFactory", name: "", type: "address" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "withdrawTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];
